import m from "../../es2015/lang/he_IL";
window.am4lang_he_IL = m;


//////////////////
// WEBPACK FOOTER
// ./lang/he_IL.js
// module id = null
// module chunks = 